<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">序时账</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top no-print">
      <Cell>
        <DatePicker type="month" v-model="period" format="YYYY-MM" style="width: 140px"
                    :clearable="false"></DatePicker>
      </Cell>
      <Cell>
        <span class="range-sep">至</span>
        <DatePicker type="month" v-model="endMonth" format="YYYY-MM" style="width: 140px"
                    placeholder="结束月份(可选)" :clearable="true"></DatePicker>
      </Cell>
      <Cell>
        <Select v-model="subjectId" :datas="subjectList" keyName="id" titleName="name" :width="220"
                :filterable="true" placeholder="全部科目"></Select>
      </Cell>
      <Cell>
        <Select v-model="zone" :datas="zoneList" keyName="key" titleName="title" :width="130"
                placeholder="全部类别"></Select>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button @click="doExport">导出</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <div class="print-header">
        <div class="print-title">序时账</div>
        <div class="print-sub">
          <span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
          <span>期间：{{printPeriod}}</span>
          <span>单位：元</span>
        </div>
      </div>
      <table class="cus-table series-table">
        <thead>
        <tr>
          <th>日期</th>
          <th>凭证字号</th>
          <th>摘要</th>
          <th>科目</th>
          <th>类别</th>
          <th>借方</th>
          <th>贷方</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in showList" :key="index">
          <td>{{ item.voucherDate }}</td>
          <td>
            <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">
              {{ item.word }}-{{ item.code }}
            </router-link>
          </td>
          <td>{{ item.summary }}</td>
          <td>{{ item.subjectName }}</td>
          <td><span :class="{'budget-tag': isBudget(item.subjectId)}">{{ subjectTypeOf(item.subjectId) }}</span></td>
          <td align="right">{{ item.debitAmount | numFormat }}</td>
          <td align="right">{{ item.creditAmount | numFormat }}</td>
        </tr>
        <tr v-if="!showList.length">
          <td colspan="7" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
        <tfoot v-if="showList.length">
        <tr>
          <td colspan="5" align="right"><b>合计</b></td>
          <td align="right"><b>{{ sum('debitAmount') | numFormat }}</b></td>
          <td align="right"><b>{{ sum('creditAmount') | numFormat }}</b></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';
import {exportCsv} from '../../js/common/export-file';

const BUDGET_TYPES = ['预算收入', '预算支出', '预算结余'];

export default {
  name: 'TimeSeries',
  data() {
    return {
      subjectList: [],
      subjectId: null,
      zone: null,
      endMonth: null,
      zoneList: [
        {key: 'FIN', title: '财务会计科目'},
        {key: 'BUDGET', title: '预算会计科目'}
      ],
      period: moment().format('YYYY-MM'),
      allList: [],
      loading: false
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    printPeriod() {
      if (!this.period) {
        return '';
      }
      let s = moment(this.period, 'YYYY-MM').format('YYYY年MM月');
      if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.period, 'YYYY-MM'), 'month')) {
        s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
      }
      return s;
    },
    subjectMap() {
      let map = {};
      this.subjectList.forEach(s => {
        map[s.id] = s;
      });
      return map;
    },
    showList() {
      let list = this.allList;
      if (this.subjectId) {
        list = list.filter(item => item.subjectId === this.subjectId);
      }
      if (this.zone === 'FIN') {
        list = list.filter(item => !this.isBudget(item.subjectId));
      } else if (this.zone === 'BUDGET') {
        list = list.filter(item => this.isBudget(item.subjectId));
      }
      return list;
    }
  },
  methods: {
    subjectTypeOf(subjectId) {
      let s = this.subjectMap[subjectId];
      return s && s.type ? s.type : '';
    },
    isBudget(subjectId) {
      let s = this.subjectMap[subjectId];
      return !!(s && BUDGET_TYPES.indexOf(s.type) > -1);
    },
    sum(field) {
      return this.showList.reduce((total, item) => total + (Number(item[field]) || 0), 0);
    },
    loadSubjects() {
      this.$api.setting.subject.voucherSelect({}).then(({data}) => {
        this.subjectList = data || [];
      }).catch(() => {
      });
    },
    loadList() {
      this.loading = true;
      let params = {accountDate: this.period};
      if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.period, 'YYYY-MM'), 'month')) {
        params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
      this.$api.accountbook.loadTimeSeries(params).then(({data}) => {
        this.allList = data || [];
      }).catch(() => {
        this.$Message.error('序时账数据加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.loadList();
    },
    doExport() {
      if (!this.showList.length) {
        this.$Message.error('暂无数据可导出');
        return;
      }
      let headers = ['日期', '凭证字号', '摘要', '科目', '类别', '借方', '贷方'];
      let rows = this.showList.map(item => [
        item.voucherDate, item.word + '-' + item.code, item.summary, item.subjectName,
        this.subjectTypeOf(item.subjectId), item.debitAmount, item.creditAmount
      ]);
      exportCsv(`序时账_${this.period}${this.endMonth ? '-' + this.endMonth : ''}`, headers, rows);
    },
    doPrint() {
      window.print();
    }
  },
  watch: {
    endMonth() {
      this.loadList();
    }
  },
  mounted() {
    this.loadSubjects();
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
  .range-sep {
    margin: 0 8px;
    line-height: 30px;
    vertical-align: middle;
  }
.series-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px 10px;
    border: 1px solid #e2e2e2;
    font-size: 13px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tfoot td {
    background: #f5f5f5;
  }

  .budget-tag {
    color: #b45f06;
    font-weight: bold;
  }
}
</style>
